import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

const SessionWarningModal: React.FC = () => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.icon}>⏰</div>
        <h3 style={styles.title}>セッションが間もなく終了します</h3>
        <p style={styles.message}>
          しばらく操作がありませんでした。
          <br />
          続けて操作する場合は「続ける」をクリックしてください。
        </p>
        <div style={styles.timer}>2:00</div>
        <div style={styles.buttonGroup}>
          <button type="button" style={styles.primaryButton}>
            続ける
          </button>
          <button type="button" style={styles.secondaryButton}>
            終了
          </button>
        </div>
      </div>
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none' as const,
    opacity: 0
  },
  modal: {
    backgroundColor: theme.whiteColor,
    padding: '32px',
    borderRadius: '12px',
    width: '320px',
    textAlign: 'center' as const,
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)'
  },
  icon: {
    fontSize: '36px'
  },
  title: {
    margin: '12px 0',
    fontSize: '18px'
  },
  message: {
    color: theme.grayTextColor,
    lineHeight: 1.6
  },
  timer: {
    fontSize: '28px',
    fontWeight: 700 as const,
    color: theme.linkColor,
    margin: '16px 0'
  },
  buttonGroup: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center'
  },
  primaryButton: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: theme.linkColor,
    color: theme.whiteColor,
    cursor: 'pointer'
  },
  secondaryButton: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: `1px solid ${theme.grayBorderColor}`,
    backgroundColor: 'transparent',
    cursor: 'pointer'
  }
});

export default SessionWarningModal;
